import * as _ from 'lodash'

const abbreviations = ['mri', 'cat']

const exclude = ['and']

export function titlecase(text: string): string {
  if (!_.isNil(text)) {
    text = String(text)
  }

  const words = (text || '')
    // break up camelCase with spaces
    .replace(/([A-Z])/g, ' $1')
    // replace hyphens with spaces
    .replace(/\-/g, ' ')
    // replace underscores with spaces
    .replace(/_/g, ' ')
    // separate words into an array
    .split(' ')

  // go through each word
  return _.map(words, (word) => {
    if (_.includes(exclude, word)) {
      return word
    }

    if (_.includes(abbreviations, word.toLowerCase())) {
      return word.toUpperCase()
    }

    const firstLetter = word.substr(0, 1).toUpperCase()
    const rest = word.substr(1)
    return firstLetter + rest
  }).join(' ')
}
